/*
 * @Author: Gaho
 * @Date: 2024-02-23 13:32:54
 * @LastEditors: Merlin
 * @LastEditTime: 2025-04-28 17:14:58
 * @Description: 
 */
export interface sectionsType {
    id: number,
    key: number
}

/* 
数字与图对应关系：  
1 = 狗头 
2 = 7号 
3 = 1条 
4 = 2条 
5 = 3条 
6 = 樱桃 
*/

export const corgiWildConfig = {
    sectors: [
        [2, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 5, 6, 6, 4, 4, 4, 2, 2, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 5, 4, 4, 4, 4], 
        [2, 3, 3, 3, 1, 5, 5, 5, 5, 5, 6, 4, 4, 4, 4, 4, 4, 4, 4, 4, 2, 3, 3, 3, 1, 5, 5, 5, 5, 5, 4, 4, 4, 4, 4, 4, 4, 4, 2], 
        [2, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 5, 6, 4, 2, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 5, 4, 4, 4, 4, 2, 2, 3, 3, 3, 4, 4]
    ],
    wins: {
        win: 10,
        bigWin: 80,
        megaWin: 10000
    }
}

